import { useSnapshot } from 'hooks/use-safe-snapshot';
import { SubscriptionModalService } from 'services/SubscriptionModalService';

import { SubscriptionModal } from './SubscriptionModal';

const GlobalSubscriptionModal = () => {
    const { options } = useSnapshot(SubscriptionModalService.state);

    if (!options) {
        return null;
    }

    return <SubscriptionModal open onClose={SubscriptionModalService.close} {...options} />;
};

export { GlobalSubscriptionModal };
